import clsx from 'clsx'
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hooks'
import { colors } from '../../../ui/colors'
import { PlusIcon } from '../../../ui/icons/plus'
import { ProjectDTO } from '../dto'
import { CreateTemplate } from './createTemplate'
import { ProjectSettings } from './projectSettings'
import { setEmailSettingsModalOpen, setEmailsSettingsTab, setOpenTemplateId } from './slice'
import { Templates } from './templatesList'
import { HTMLfy, variablesMap } from './utils'

interface Props {
    project: ProjectDTO
}

export function EmailSettingModal({ project }: Props) {
    const mailsState = useAppSelector(state => state.mails)
    const dispatch = useAppDispatch()

    function updateTemplate(text: string) {
        const customText = text.replace(/\[([^\]]+)\]/g, (match, word) => `${variablesMap.get(word)}`)
        const HTMLtext = HTMLfy(customText)
        return [customText, HTMLtext]
    }

    function stripHtml(html: string): string {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "";
    }

    if (mailsState.openEmailSettingsModal)
        return (
            <div className='transition-all fixed bg-opacity-30 bg-neutral-950 backdrop-blur-sm top-0 left-0 h-full w-full flex items-center justify-center z-[100]'>
                <div className='transition-all relative flex flex-col bg-white rounded-xl opacity-100 shadow-sm w-[760px]'>
                    <div
                        onClick={() => {
                            // dispatch(resetCreateCustomMailRequest())
                            // setOpenVariables(false)
                            dispatch(setOpenTemplateId(undefined))
                            dispatch(setEmailSettingsModalOpen(false))
                        }}
                        className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
                    >
                        <PlusIcon color={colors.brandPrimary[600]} size={16} />
                    </div>
                    <div className="p-6 text-heading-xs font-semibold text-center">
                        Impostazioni invio e-mail
                    </div>
                    <div className='flex gap-4 px-6 pt-2 text-text-sm font-medium text-neutral-600 border-y-neutral-200 border-y'>
                        {
                            ['Nuovo template', 'Archivio template', 'Impostazioni invio'].map((item, index) =>
                                <div onClick={() => dispatch(setEmailsSettingsTab(index))}
                                    className={clsx('p-3 cursor-pointer', { 'border-b-brandPrimary-500 border-b-2': mailsState.emailSettingsTab === index })}
                                >
                                    {item}
                                </div>
                            )
                        }
                    </div>
                    <div className="px-6 py-8 flex flex-col justify-center items-center gap-6 w-full">
                        {
                            mailsState.emailSettingsTab === 0 &&
                            <CreateTemplate
                                project={project}
                                updateTemplate={updateTemplate}
                                stripHtml={stripHtml}
                            />
                        }
                        {
                            mailsState.emailSettingsTab === 1 &&
                            <Templates
                                project={project}
                                updateTemplate={updateTemplate}
                                stripHtml={stripHtml}
                            />
                        }
                        {
                            mailsState.emailSettingsTab === 2 &&
                            <ProjectSettings project={project} />
                        }
                    </div>
                </div>
            </div>
        )
    else return <></>
}
